export default __webpack_public_path__ + "static/media/niifi-logo-dark.6b99032e.png";